import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import yaml from "js-yaml";
import {normalizeSupportedLocale} from "./constants/locales";

/** Last locale we know is already persisted via PUT (e.g. SelectLocale page); avoids duplicate PUT after i18n sync. */
let lastLocaleSyncedOnServer = null;

/** Call after a successful PUT /api/user/locale elsewhere so languageChanged does not repeat the same request. */
export function markUserLocalePersistedOnServer(locale) {
    lastLocaleSyncedOnServer = normalizeSupportedLocale(locale, "en");
}

const LANG_STORAGE_KEY = "efics_lang";

const getInitialLanguage = () => {
    const savedLang = localStorage.getItem(LANG_STORAGE_KEY);
    if (savedLang) {
        return normalizeSupportedLocale(savedLang);
    }
    return normalizeSupportedLocale(navigator.language, "en");
};

const yamlBackend = {
    type: "backend",
    read: (language, _namespace, callback) => {
        fetch(`/api/i18n/${language}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Failed to load language ${language}`);
                }
                return response.text();
            })
            .then((text) => {
                const parsed = yaml.load(text) || {};
                callback(null, parsed);
            })
            .catch((error) => callback(error, false));
    }
};

i18n
    .use(yamlBackend)
    .use(initReactI18next)
    .init({
        lng: getInitialLanguage(),
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        }
    });

i18n.on("languageChanged", (language) => {
    localStorage.setItem(LANG_STORAGE_KEY, language);
    const normalized = normalizeSupportedLocale(language, "en");
    if (lastLocaleSyncedOnServer === normalized) {
        return;
    }
    lastLocaleSyncedOnServer = normalized;
    fetch("/api/user/locale", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ locale: normalized })
    })
        .then((res) => {
            if (!res.ok) {
                lastLocaleSyncedOnServer = null;
            }
        })
        .catch(() => {
            lastLocaleSyncedOnServer = null;
        });
});

export default i18n;
